import React, { useState, useEffect } from "react";
import styled, { withTheme } from "styled-components";
import Chart from "react-apexcharts";

import { Box } from "vqp-common";
import { CardTitle } from "./";
import lightenDarkenColor from "../../utils/lightenDarkenColor";

const CustomBox = styled(Box)`
  height: 350px !important;
`;

const getDefaultChartOptions = () => ({
  chart: {
    toolbar: {
      show: false,
    },
  },
  legend: {
    position: "bottom",
    horizontalAlign: "center",
  },
});

function generateColor() {
  const letters = "0123456789ABCDEF";
  let color = "#";

  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }

  return color;
}

const getDefaultColors = (theme) => [
  theme.colors.primary,
  theme.colors.secondary,
  "#536B53",
  "#F7A8D8",
  "#9BF1C9",
  "#5B0EBE",
];

const Wrapper = styled.div``;

export const PieChart = withTheme(({ title, labels, data, type, theme }) => {
  const defaultColors = getDefaultColors(theme);
  const chartOptions = getDefaultChartOptions();
  const [chartSeries, setChartSeries] = useState([]);

  const safeLabels = Array.isArray(labels) ? labels : [];
  const rawData = Array.isArray(data) ? data : [];
  const safeData = rawData.map((d) => (typeof d === 'number' ? d : (d && typeof d === 'object' && typeof d.value === 'number' ? d.value : 0)));

  chartOptions.labels = safeLabels.map((item) => {
    const down = String(item).toLowerCase();
    const label = down ? down[0].toUpperCase() + down.substring(1) : "";
    return label;
  });

  chartOptions.colors = rawData.map((d, i) => (d && typeof d === 'object' && d.color) || defaultColors[i % defaultColors.length]);

  // Lazy load chart series to force animation; ApexCharts pie expects array of numbers
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setChartSeries(safeData);
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [data]);

  const hasValidSeries = Array.isArray(chartSeries) && chartSeries.length > 0 && chartSeries.some((n) => Number(n) > 0);

  return (
    <Wrapper>
      <CardTitle>{title}</CardTitle>
      <CustomBox padding={"20px"}>
        {hasValidSeries ? (
          <Chart
            options={chartOptions}
            series={chartSeries}
            type={type}
            height={290}
            width={"95%"}
          />
        ) : null}
      </CustomBox>
    </Wrapper>
  );
});
